/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Actionendtimelabel3Inputs */

const en_actionendtimelabel3 = /** @type {(inputs: Actionendtimelabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Time`)
};

const de_actionendtimelabel3 = /** @type {(inputs: Actionendtimelabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uhrzeit`)
};

/**
* | output |
* | --- |
* | "Time" |
*
* @param {Actionendtimelabel3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const actionendtimelabel3 = /** @type {((inputs?: Actionendtimelabel3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actionendtimelabel3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_actionendtimelabel3(inputs)
	return de_actionendtimelabel3(inputs)
});
export { actionendtimelabel3 as "actionEndTimeLabel" }